export const TRANSLATIONS_EN = {
  academie: "education",
  usage: "guide",
  marche: "market",
  planification: "planning",
  rapport: "Reports",
};
